import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Flash, BorderBox } from '@primer/components';
import { InfoIcon } from '@primer/styled-octicons';
import { ExternalLink, GithubIssue } from '../../src/components';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Installation`}</h2>
    <Flash mb={2} mdxType="Flash">
    <InfoIcon ml={1} mdxType="InfoIcon" /> XEDI.js is currently published to the GitHub Package Repository. You can find out more about the GitHub Package Repository <ExternalLink href="https://help.github.com/en/packages" mdxType="ExternalLink">here</ExternalLink>.
    <BorderBox mt={1} bg="white" mdxType="BorderBox">
        <GithubIssue issueId="29" mdxType="GithubIssue" />
    </BorderBox>
    </Flash>
    <p><strong parentName="p">{`Using NPM`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @xedi/sdk-js
`}</code></pre>
    <p>{`XEDI.js also ships with TypeScript typings!`}</p>
    <h2>{`Configuration`}</h2>
    <p>{`You can configure the SDK using the `}<inlineCode parentName="p">{`Xedi.Config`}</inlineCode>{` class. This class extends a JavaScript `}<inlineCode parentName="p">{`Map`}</inlineCode>{` object, so the usual `}<inlineCode parentName="p">{`get`}</inlineCode>{`, `}<inlineCode parentName="p">{`set`}</inlineCode>{`, and `}<inlineCode parentName="p">{`delete`}</inlineCode>{` methods will work as per the original object. For example, you can configure which `}<inlineCode parentName="p">{`base_url`}</inlineCode>{` should be used to contact a API Gateway instance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Xedi.Config.set('base_url', 'https://api.staging.xedi.com');
`}</code></pre>
    <p>{`Below you will find a list of all configurations.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Configuration`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Comments`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`base_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`https://api.xedi.com`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`refresh_token`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set and managed by `}<inlineCode parentName="td">{`Xedi.Auth`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`access_token`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set and managed by `}<inlineCode parentName="td">{`Xedi.Auth`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`mode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`production`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Learn more about using the `}<inlineCode parentName="p">{`Xedi.Config`}</inlineCode>{` class `}<Link to="development/configuration" mdxType="Link">{`here`}</Link>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      